<template>
  <Head title="Avid - Sign Up" />
  
  <div class="container-fluid d-flex flex-column h-100 onboarding-container">
    <onboarding-wiland :error="errors"></onboarding-wiland>
  </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';

defineProps({
  errors: Object
});
</script>

